import {
    apiRequest,
    riwayatPangkatDetail,
    riwayatPangkatLogDetail
} from "../../../../../services/adapters/kepegawaian/riwayatPangkatService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatPangkatDetail, {
            params: query
        }, true)
    }
    fetchLogDetail = async (query) => {
        return await apiRequest("get", riwayatPangkatLogDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository